import { render } from "./OrderModalHeader.vue?vue&type=template&id=cbe0c0d0"
import script from "./OrderModalHeader.vue?vue&type=script&lang=js"
export * from "./OrderModalHeader.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_4ea0b76e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__